import axios from 'axios';
import { url } from '../config';

// Redux actions
import { FETCH_WORK, FAILED_WORK } from '../actions/index.jsx';

// Axios Request
export const fetchWork = (post_type) => {
    return function (dispatch) {
        axios
            .get(`${url}/wp-json/wp/v2/${post_type}?per_page=30`)
            .then((response) => {
                dispatch({
                    type: FETCH_WORK,
                    payload: response.data,
                });
            })
            .catch(function (error) {
                dispatch({
                    type: FAILED_WORK,
                });
            });
    };
};



// WEBPACK FOOTER //
// ./src/requests/work_request.js